import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("USERTABLE");

 const resetData = actionCreator<{data:userdata[]}>("USERTABLE_RESETDATA");

 export const TableThingyActions = { resetData}


